import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
} from '@angular/forms';
import { CommonService } from 'src/app/services/common-services/common.service';
import { environment } from 'src/environments/environment';
import { OtherValueStatePayload } from '../create-rfq/create-rfq.component';

@Component({
  selector: 'app-popup-dropdown',
  templateUrl: './popup-dropdown.component.html',
  styleUrls: ['./popup-dropdown.component.scss'],
})
export class PopupDropdownComponent implements OnInit {
  @Output() backButton = new EventEmitter<string>();
  @Output() categoryParent = new EventEmitter<any>();
  @Input('categoriesData') categoriesData: any;
  @Input('alreadySelectedCategories') alreadySelectedCategories: any;
  @Input('alreadySelectedSubCategories') alreadySelectedSubCategories: any;

  @Input() otherSubCategoryValue = '';
  @Output() updateOtherSubCatValue = new EventEmitter<OtherValueStatePayload>();

  baseUrl = environment.BASE_URL;
  categoryData: any[] = [];
  clickedCategory: any = 0;
  searchForm!: FormGroup;
  selectedCategories: any[] = [];
  subCategoriesList: any[] = [];
  filteredData: any[] = [];

  isOtherSubCategoryInputVisible = false;
  isSaveBtnActive = true;

  private categoryInputState = {
    OthersForCategory: false,
    OthersForSubCategory: false,
  };

  constructor(
    private formBuilder: FormBuilder,
    private profileData: CommonService
  ) {}

  ngOnInit(): void {
    this.getCategory();
    this.searchForm = this.formBuilder.group({
      searchText: [''],
    });
    this.filterItems();
    this.setAlreadySelected();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.otherSubCategoryValue) {
      this.isSaveBtnActive = true;
      this.isOtherSubCategoryInputVisible = true;
    }

    //console.log(this.categoriesData, '????>>>>>>>>>');

    if (this.categoriesData) {
      this.categoriesData =  this.getClonedCatAndSubCat(this.categoriesData);

      this.filteredData = this.categoriesData;
      this.subCategoriesList = this.filteredData[0]?.sub

    }
  }

  handleSaveBtn() {
    this.isSaveBtnActive = this.isOtherSubCategoryInputVisible
      ? !!this.otherSubCategoryValue
      : true;
  }

  setAlreadySelected() {
    if (this.alreadySelectedCategories?.length) {
      this.alreadySelectedCategories?.forEach((element: any) => {
        for (let val of this.filteredData) {
          if (element.name == val.name) {
            val.isChecked = true;
          }
        }
      });
    }

    if (this.alreadySelectedSubCategories?.length) {
      this.alreadySelectedSubCategories?.forEach((element: any) => {
        this.filteredData.forEach((ele: any) => {
          for (let val of ele?.sub) {
            if (val?.name == element?.name) {
              val.isChecked = true;
            }
          }
        });
      });
    }
    this.categoryParent.emit(this.categoriesData);
  }

  getClonedCatAndSubCat(list : any[]){
    list = list.map(item => {
      return {...item, sub : item.sub.map((i : any) => {
        return {...i}
      })}
    });

    return list;
  }


  getSubcategories(id: any): void {
    this.subCategoriesList = this.categoriesData.find(
      (item: any) => item.id == id
    )?.sub
  }

  getCategory() {
    // this.profileData.getData(`${this.baseUrl}common-service/category-management`).subscribe(res => {
    //   this.categoryData = res?.response;
    //   this.initializeChecks(this.categoryData);
    // });
  }
  filterItems() {
    const searchText = this.searchForm
      .get('searchText')
      ?.valueChanges.subscribe((value) => {
        this.filteredData = this.categoriesData.filter((item: any) =>
          item.name.toLowerCase().includes(value.toLowerCase())
        );
        this.subCategoriesList = this.filteredData[0]?.sub;
        if (value == '') {
          this.filteredData = this.categoriesData;
        }
      });
  }
  initializeChecks(data: any) {
    // data.forEach((item: any) => {
    //   item['isChecked'] = false;
    //   if (data?.subcategories?.length) {
    //     this.initializeChecks(data.subcategories);
    //   }
    // })
  }
  getSelectedCategories() {
    // this.categoriesData.forEach((item:any)=>{
    //   if(item.isChecked && !this.selectedCategories.filter((x:any)=>x.id == item.id).length && !item?.subcategories?.filter((x:any)=>x.isChecked == true).length){
    //     this.selectedCategories.push({id: item.id, name: item.categoryName})
    //   }
    //   if(item.subcategories.length){
    //     item.subcategories.forEach((value:any)=>{
    //       if(value.isChecked)
    //        this.selectedCategories.push({id: value.id, name: value.subCategoryName})
    //     })
    //   }
    // })
    //
    this.categoryParent.emit(this.categoriesData);
    this.backButton.emit();
    this.updateOtherSubCatValue.emit({
      key: 'category',
      value: this.otherSubCategoryValue,
    });
    // console.log(this.selectedCategories);
  }

  clickCategory(index: any) {
    // this.clickedCategory = index;
  }
  isCategoryChecked(index: any) {
    // let isChecked = false;
    // this.categoryData[index].subcategories.forEach((cat: any) => {
    //   if (cat.isChecked) {
    //     isChecked = true
    //   }
    // })
    // return isChecked;
  }

  backClick() {
    this.unCheckAll();
    this.backButton.emit();
  }

  unCheckAll() {
    this.isOtherSubCategoryInputVisible = false;
    // this.updateOtherSubCatValue.emit({
    //   key : 'category',
    //   value : ''
    // });
    this.otherSubCategoryValue = '';
    this.categoriesData.forEach((item: any) => {
      item.isChecked = false;
      if (item?.sub?.length > 0)
        item?.sub.forEach((value: any) => {
          value.isChecked = false;
        });
    });
    // this.categoryParent.emit(this.categoriesData);
  }

  onCheckboxChange(item: any) {
    const itemName = (item.name as string).toLocaleLowerCase();

    if (itemName === 'others') {
      this.handleSubCategoryInputVisibility(
        'OthersForCategory',
        item.isChecked
      );

      if(!item.isChecked){
        this.otherSubCategoryValue = '';
      }
    }

    if (!item.isChecked)
      item.sub.forEach((value: any) => (value.isChecked = false));
  }

  selectParentFromChild(item: any) {
    const itemName = (item.name as string).toLocaleLowerCase();

    if (itemName === 'others') {
      this.handleSubCategoryInputVisibility(
        'OthersForSubCategory',
        item.isChecked
      );

      if(!item.isChecked){
        this.otherSubCategoryValue = ''
      }
    }

    if (item.isChecked) {
      this.categoriesData.forEach((value: any) => {
        if (value.sub.find((x: any) => x.id == item.id)) value.isChecked = true;
      });
    }
  }

  handleSubCategoryInputVisibility(
    key: keyof typeof this.categoryInputState,
    value: boolean
  ) {
    type Key = keyof typeof this.categoryInputState;

    if (key === 'OthersForCategory' && value === false) {
      Object.keys(this.categoryInputState).forEach((k) => {
        this.categoryInputState[k as Key] = false;
      });
    } else if (key === 'OthersForSubCategory' && value === true) {
      Object.keys(this.categoryInputState).forEach(
        (k) => (this.categoryInputState[k as Key] = true)
      );
    } else {
      this.categoryInputState[key] = value;
    }
    this.isOtherSubCategoryInputVisible = !Object.values(
      this.categoryInputState
    ).includes(false);

    this.handleSaveBtn();
  }
}
